import ModuleCard from "./module-card";

export { ModuleCard };
